<template>
    <div>

        <config-main-title>
            Balanço Hídrico
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <importacao service="balanco_items" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"  @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum item de balanço hídrico identificado.'" 
                icon="fas fa-water"
                :action="'Incluir'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2" v-if="dado.id_balanco_item">#{{ dado.id_balanco_item }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <i class="fa fa-sign-out text-danger" title="Saída" aria-hidden="true" v-if="dado.in_fator < 0"></i>
                            <i class="fa fa-sign-in text-success" title="Saída" aria-hidden="true" v-else-if="dado.in_fator > 0"></i>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_balanco_item ) ? '' : 'Novo' }}
                            Balanço Hídrico
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_balanco_item">
                                #{{ item.id_balanco_item }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    placeholder="Informe o nome do item..."
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    placeholder="Direção..."
                                    label="Direção"
                                    :validate="validate"
                                    required
                                    type="select"
                                    :optionsList="[
                                        { id: 1, search: 'Entrada' }, 
                                        { id: -1, search: 'Saída' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.in_fator" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_obs" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="balancoItem" :id="item.id_balanco_item" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_balanco_item ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Importacao from '../shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false, 
            options_classes: [], 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        Importacao, 
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let reg = this.$util.getregex(this.search);

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },
    },

    methods: { 
        incluir () { 
            this.validate = false;

            let item = {
                id_balanco_item: null,
                st_nome: "", 
                fl_ativo: true,
                st_obs: "", 
                in_fator: 1,
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'balanco_items',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            if ( item.id_balanco_item ) { 

                this.$util.loadItem(this, { 
                    service: 'balanco_items',
                    func: 'show',
                    parms: { 
                        id: item.id_balanco_item,
                        cadastro: true, 
                    }
                })
                .then(res => { 
                    this.item = res;
                    $('#edicaoModal').modal('show');
                });

            } else { 

                this.item = _.cloneDeep (item);
                $('#edicaoModal').modal('show');

            }

        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'balanco_items',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 
            this.$util.toggle(this, { 
                service: 'balanco_items',
                dados: item,
            });
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Balanço Hídrico", path: "/config/balanco-hidrico" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style scoped>
.modal-dialog-alto {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>